module.exports = __webpack_public_path__ + "static/media/SS3.cbc3dff9.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Trip/SS3.jpeg
// module id = 275
// module chunks = 0